import { Graph } from "mementus/src/mementus";
import PolicyGraphAggregator from "./PolicyGraphAggregator";

class PolicyGraph {
  constructor(graph) {
    this.graph = graph;
  }

  countries() {
    return this.graph.nodes("country");
  }

  sectors() {
    return this.graph.nodes("sector");
  }

  interventions() {
    return this.graph.nodes("intervention");
  }

  categories() {
    return this.graph.nodes("category");
  }

  entry(id) {
    const query = this.graph.n({id});

    return {
      ...query.props().one(),
      countries: query.out("for_country").prop("name").all(),
      sectors: query.out("for_sector").prop("name").all(),
      interventions: query.out("of_type").prop("name").all(),
      categories: query.out("for_category").prop("name").all()
    }
  }

  policiesFor(countryId, sectors, interventions, categories) {
    // Traverse to the entries with edges pointing to the given country
    const query = this.graph.n({id: countryId}).inc("for_country");

    if (sectors.length > 0) {
      // Filter entries that have an edge to the given sectors.
      // TODO: determine every vs some selection.
      query.where(n => n.out("for_sector").id().all().every(s => (
        sectors.includes(s)
      )));
    }

    if (interventions.length > 0) {
      // Filter entries that have an edge to the given intervention types.
      // TODO: determine every vs some selection.
      query.where(n => n.out("of_type").id().all().every(i => (
        interventions.includes(i)
      )));
    }

    if (categories.length > 0) {
      // Filter entries that have an edge to the given categories.
      // TODO: determine every vs some selection.
      query.where(n => n.out("for_category").id().all().every(c => (
        categories.includes(c)
      )));
    }

    // Strip policy metadata out of the graph structure and return it as a list.
    return query.all();
  }

  statsFor(countryId) {
    return this.graph.n({id: countryId}).inc("metrics_of").props().all();
  }
}

// Loads formatted policy and stats data into the graph representation.
PolicyGraph.load = function(policyData, statsData) {
  const graph = new Graph(graphBuilder => {
    const aggregator = new PolicyGraphAggregator(
      graphBuilder,
      policyData,
      statsData
    );
    aggregator.buildGraph();
  });

  return new PolicyGraph(graph);
}

export default PolicyGraph;
